import styled from "styled-components";

export const AppContainer = styled.div`
  padding: 15px;
  min-height: 520px;
`;

export const DescriptionBox = styled.div`
  div {
    min-height: 230px;
  }
`;

export const RadioButtonsContainer = styled.fieldset`
  min-height: 310px;
`;

export const NavigationFooter = styled.div`
  margin-top: 15px;
`;

export const ValuationAmount = styled.div`
  border: 1px solid #000;
  padding: 5px;
  text-align: center;
  &:empty {
    border: 0;
  }
`;

export const PageContent = styled.div`
  min-height: 310px;
`;

export const CarsaHeader = styled.nav`
  background: #ffffff;
  height: 50px;
  padding: 15px;
  margin-bottom: 15px;
  border-radius: 4px;

  .breadcrumb {
    background: inherit;
    padding: 0 0 0 4px;
  }
  li {
    color: #777;
  }
  li:before {
    color: #ccc;
    content: "/ ";
    padding: 0 5px;
  }
`;

export const CarsaLogo = styled.div`
  background: #ffffff
    url(https://carsanet.dealernetdms.co.uk/media/img/public/carsanet/logo_v2.png)
    no-repeat;
  background-size: contain;
  height: 20px;
`;
